import { useSearchParams } from 'react-router-dom'
import useAuth from '../../common/hooks/useAuth'
import { useRef, useState } from 'react'
import Button from '../../components/common/Button'
import { setSearchParams } from '../../common/helpers'
import InlineStack from '../../components/common/InlineStack'
import { TASK_STATUSES } from '../../common/constants'
import Divider from '../../components/common/Divider'
import Break from '../../components/common/Break'
import TasksList from '../admin/tasks/TasksList/TasksList'

const statusTabs = [
    TASK_STATUSES.REVIEW,
    TASK_STATUSES.REJECTED,
    TASK_STATUSES.ACCEPTED,
    TASK_STATUSES.OPEN,
    TASK_STATUSES.DENIED,
    TASK_STATUSES.APPROVAL,
    TASK_STATUSES.RECREATION,
    TASK_STATUSES.BLOCKED,
    TASK_STATUSES.HOLD,
]

export default function UserTasks({ role, userId }) {
    const auth = useAuth()
    const [searchParams] = useSearchParams()
    const tagFromParams = searchParams.get('tag_task_list')
    const ref = useRef(null)
    const [hasTag, setHasTag] = useState(tagFromParams)

    function handleCloseTagTasks() {
        const paramsObj = Object.fromEntries(searchParams)
        delete paramsObj.tag_task_list
        setSearchParams(paramsObj)
        setHasTag(false)
    }

    const isOwnProfile = auth.user.id === userId

    if (isOwnProfile && role === 'user') {
        return (
            <>
                <h2 className="h3">Homework</h2>
                <TasksList
                    targetClient
                    associatedClientId={userId}
                    associatedClientType="User"
                    statusTabs={statusTabs}
                    renderMainButton={false}
                />
                <Break />
                <Divider />
                <h2 className="h3">Team Tasks</h2>
                <TasksList
                    targetTeam
                    targetRole
                    associatedClientId={userId}
                    associatedClientType="User"
                    renderMainButton={false}
                    clientReviewStatus={'submitted'}
                />
            </>
        )
    }

    return (
        <>
            {role === 'user' ? (
                <>
                    <h2 className="h3">Homework</h2>
                    <TasksList
                        targetClient
                        associatedClientId={userId}
                        associatedClientType="User"
                        statusTabs={statusTabs}
                        newItemPath={`/users/${userId}/tasks/new`}
                        newItemLabel={'New Homework'}
                        renderMainButton={false}
                    />
                    <Break />
                    <Divider />
                    <h2 className="h3">Team Tasks</h2>
                    <TasksList
                        targetTeam
                        targetRole
                        associatedClientId={userId}
                        associatedClientType="User"
                        statusTabs={statusTabs}
                        assignedTeamMemberId={auth.isStaff ? userId : undefined}
                        renderMainButton={false}
                    />
                </>
            ) : (
                <>
                    {Boolean(hasTag) && (
                        <>
                            <InlineStack gap={'sm'} spaceBetween>
                                <h2
                                    ref={ref}
                                    className="h3"
                                    id="tag-tasks"
                                >{`Tasks tagged "${tagFromParams}"`}</h2>
                                <Button
                                    text="Close"
                                    tiny
                                    outline
                                    onClick={handleCloseTagTasks}
                                />
                            </InlineStack>
                            <TasksList
                                assignedTeamMemberId={userId}
                                statusTabs={statusTabs}
                                tag={tagFromParams}
                            />
                            <br />
                            <br />
                            <h2 className="h3">Tasks</h2>
                        </>
                    )}

                    <TasksList
                        assignedTeamMemberId={userId}
                        statusTabs={statusTabs}
                        newItemPath={`/users/${userId}/tasks/new`}
                    />
                </>
            )}
        </>
    )
}
